import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import pt from './pt.json';

export const locales = {
  de,
  en,
  es,
  fr,
  it,
  pt,
} as const;
